import React from 'react';
import { Stack } from '@rossum/ui/material';
import { SidebarSectionTitle } from './SidebarSectionTitle';

type SidebarContainerProps = {
  children: React.ReactNode;
  title: string;
};

// TODO: @sidebarV2 can we find a way to use this for items sections as well? Is it a good abstraction?
export const SidebarContainer = ({
  children,
  title,
}: SidebarContainerProps) => {
  return (
    <>
      <SidebarSectionTitle title={title} />
      <Stack spacing={2} sx={{ pl: 2, pr: 1 }}>
        {children}
      </Stack>
    </>
  );
};
